import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function VisitGuide() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-10">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('access.visit.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('access.visit.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('access.visit.titleEn')}
          </p>
          <div className="gold-line mx-auto"></div>
          <p className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto mt-5">
            {t('access.visit.lead')}
          </p>
        </div>

        <div className="border border-background-200/60 bg-background-50 p-8">
          <div className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-6">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                <i className="ri-calendar-check-line text-accent-600 text-base"></i>
              </div>
              <div>
                <h4 className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium mb-2">
                  {t('access.visit.0.title')}
                </h4>
                <p className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                  {t('access.visit.0.text')}
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-6">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                <i className="ri-eye-line text-accent-600 text-base"></i>
              </div>
              <div>
                <h4 className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium mb-2">
                  {t('access.visit.1.title')}
                </h4>
                <p className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                  {t('access.visit.1.text')}
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-6">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                <i className="ri-compass-3-line text-accent-600 text-base"></i>
              </div>
              <div>
                <h4 className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium mb-2">
                  {t('access.visit.2.title')}
                </h4>
                <p className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-3">
                  {t('access.visit.2.text')}
                </p>
                <div className="flex flex-wrap gap-3">
                  <Link
                    to="/consultation"
                    className="text-[13px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors inline-flex items-center gap-1.5"
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-chat-1-line text-xs"></i>
                    </div>
                    {t('access.visit.2.link0')}
                  </Link>
                  <Link
                    to="/seminar"
                    className="text-[13px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors inline-flex items-center gap-1.5"
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-lightbulb-line text-xs"></i>
                    </div>
                    {t('access.visit.2.link1')}
                  </Link>
                  <Link
                    to="/contact"
                    className="text-[13px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors inline-flex items-center gap-1.5"
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-mail-line text-xs"></i>
                    </div>
                    {t('access.visit.2.link2')}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
